import React from 'react';
import { useStyletron } from 'baseui';
import { FILL, Tab as BaseTab, Tabs as BaseTabs } from 'baseui/tabs-motion';
import { LabelSmall } from 'baseui/typography';
import { TabsM3 as TabsConfig } from '../side-panel/const';
import { useSidePanel } from '../side-panel/side-panel-provider';
import type { TabsType } from '../side-panel/types';
import { AnnotationsPanel } from './annotations/annotations-panel';
import { LabelPanel } from './labels/label-panel';
export const SidePanel = () => {
  const {
    onTabChange,
    activeTab,
    setActiveTab
  } = useSidePanel();
  const [css, theme] = useStyletron();
  return <div className={css({
    width: '100%'
  })}>
      <BaseTabs fill={FILL.fixed} activeKey={activeTab} onChange={({
      activeKey
    }) => {
      setActiveTab((activeKey as TabsType));
      onTabChange?.((activeKey as string));
    }} overrides={{
      Root: {
        style: {
          height: theme.sizing.scale1200,
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }
      }
    }}>
        {Object.values(TabsConfig).map(tab => <BaseTab key={tab.key} title={<LabelSmall margin={0}>{tab.title}</LabelSmall>} overrides={{
        TabPanel: {
          style: {
            // Subtracting header and relationship list item height
            minHeight: `calc(100vh - ${theme.sizing.scale1200} - ${theme.sizing.scale1400})`,
            padding: 0
          }
        }
      }}>
            <div className={css({
          width: '100%',
          height: `calc(100% - ${theme.sizing.scale600})`,
          padding: theme.sizing.scale600,
          paddingTop: 0,
          paddingBottom: 0,
          boxSizing: 'border-box'
        })}>
              {tab.key === TabsConfig.CLASSES.key && <LabelPanel />}
              {tab.key === TabsConfig.ANNOTATIONS.key && <AnnotationsPanel />}
            </div>
          </BaseTab>)}
      </BaseTabs>
    </div>;
};